import React from 'react';
import styled, { css } from 'styled-components';
import theme from 'theme';

import AffiliateArrow from 'components/icons/AffiliateArrow';
import Play from 'components/icons/Play';
import SectionTitle from 'components/previewPages/SectionTitle';

type Props = {
  isMobile: boolean;
  goToNextSection: () => void;
};

const WellnessSection = ({ isMobile, goToNextSection }: Props) => {
  return (
    <Container $isMobile={isMobile}>
      <SectionTitle isMobile={isMobile}>
        Discover connected wellness
      </SectionTitle>
      <Subtitle $isMobile={isMobile}>
        {`Shido unites physical and mental health\nfor a balanced life - all in one powerful app`}
      </Subtitle>

      <VideoWrapper $isMobile={isMobile}>
        <VideoBubble />
        <img
          src="/images/affiliateWellness.png"
          alt="Discover connected wellness"
        />
        <ButtonWrapper>
          <ButtonBorder $isMobile={isMobile}>
            <PlayButton>
              <PlayIcon color={theme.colors.white} $isMobile={isMobile} />
            </PlayButton>
          </ButtonBorder>
        </ButtonWrapper>
      </VideoWrapper>

      <ArrowWrapper onClick={goToNextSection}>
        <AffiliateArrow />
      </ArrowWrapper>
    </Container>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  position: absolute;
  left: 0;
  right: 0;
`;

const ButtonBorder = styled.div<{ $isMobile: boolean }>`
  width: 100px;
  height: 100px;
  border: 10px solid rgba(255 255 255 / 50%);
  border-radius: 50%;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      width: 60px;
      height: 60px;
    `}
`;

const PlayButton = styled.button`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.lightBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const PlayIcon = styled(Play)<{ $isMobile: boolean }>`
  width: 33px;
  height: 32px;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      width: 21px;
      height: 20px;
    `}
`;

const VideoWrapper = styled.div<{ $isMobile: boolean }>`
  position: relative;
  height: 728px;
  width: 732px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      width: 357px;
      height: 355px;
    `}

  & img {
    width: 100%;
    height: 100%;
    z-index: 2;
  }
`;

const VideoBubble = styled.div`
  box-sizing: border-box;
  position: absolute;
  right: 0;
  left: 0;
  width: 90%;
  height: 90%;
  max-width: 100%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  opacity: 0.15;
  border: 1px dashed ${({ theme }) => theme.colors.white};
  border-radius: 50%;
`;

const Subtitle = styled.p<{ $isMobile: boolean }>`
  font-size: 20px;
  font-weight: 300;
  line-height: 35px;
  color: ${({ theme }) => theme.colors.topicBlue};
  text-align: center;
  margin-bottom: 34px;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: 14px;
      line-height: 20px;
      white-space: pre-line;
    `}
`;

const ArrowWrapper = styled.div`
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
`;

const Container = styled.section<{ $isMobile: boolean }>`
  max-width: 1400px;
  padding: 78px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px dashed rgba(65 78 113 / 25%);
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      padding: 34px 0;
    `}
`;

export default WellnessSection;
